export enum RuntimeEnum {
  RequestFailed = 'The request failed and the interceptors did not return an alternative response',
}
